import {Component, ComponentInterface, h, Prop} from '@stencil/core';
import {type SolIconSize, SolIconSizeEnum} from '../sol-icon/types/sol-icon-sizes';
import type {SolIconNames} from '../sol-icon/types/sol-icon-names';
import {SolIconBubbleVariantEnum, type SolIconBubbleVariant} from './types/sol-icon-bubble';

const iconSizeMap = {
  [SolIconSizeEnum.s12]: SolIconSizeEnum.s12,
  [SolIconSizeEnum.s16]: SolIconSizeEnum.s12,
  [SolIconSizeEnum.s20]: SolIconSizeEnum.s12,
  [SolIconSizeEnum.s24]: SolIconSizeEnum.s12,
  [SolIconSizeEnum.s28]: SolIconSizeEnum.s16,
  [SolIconSizeEnum.s32]: SolIconSizeEnum.s16,
  [SolIconSizeEnum.s36]: SolIconSizeEnum.s16,
  [SolIconSizeEnum.s40]: SolIconSizeEnum.s20,
  [SolIconSizeEnum.s44]: SolIconSizeEnum.s24,
  [SolIconSizeEnum.s56]: SolIconSizeEnum.s28,
};

const iconPaddingMap = {
  [SolIconSizeEnum.s12]: '4',
  [SolIconSizeEnum.s16]: '4',
  [SolIconSizeEnum.s20]: '4',
  [SolIconSizeEnum.s24]: '4',
  [SolIconSizeEnum.s28]: '4',
  [SolIconSizeEnum.s32]: '6',
  [SolIconSizeEnum.s36]: '8',
  [SolIconSizeEnum.s40]: '8',
  [SolIconSizeEnum.s44]: '8',
  [SolIconSizeEnum.s56]: '12',
};

@Component({
  tag: 'sol-icon-bubble',
  styleUrl: 'sol-icon-bubble.scss',
  shadow: true,
})
export class SolIconBubble implements ComponentInterface {
  @Prop()
  icon?: SolIconNames;

  @Prop()
  size: SolIconSize = SolIconSizeEnum.s24;

  @Prop()
  variant: SolIconBubbleVariant = SolIconBubbleVariantEnum.default;

  @Prop()
  isOpaque: boolean = false;

  private get iconSize(): SolIconSize {
    return iconSizeMap[this.size] as SolIconSize;
  }

  private get _padding() {
    return iconPaddingMap[this.size];
  }

  render() {
    return (
      <span
        class={`
          sol-icon-bubble
          sol-icon-bubble--${this.variant}
          ${this.isOpaque ? `sol-icon-bubble--${this.variant}-opaque` : ''}
          sol-icon-bubble--padding-${this._padding}
        `}
      >
        <sol-icon icon={this.icon} size={this.iconSize}></sol-icon>
      </span>
    );
  }
}
